import { styled } from '@linaria/react';
import { useSpring } from 'react-spring';
import { motion } from 'framer-motion';

import Box from './Box';
import Code from './Code';
import Wrapper from './Wrapper';

function getIndicatorPosition(origin) {
  switch (origin) {
    case 'center':
      return { left: '50%', top: '50%' };
    case 'left top':
      return { left: '0%', top: '0%' };
    case '25px bottom':
      return { left: '25px', top: '100%' };
    case '0% 150%':
      return { left: '0%', top: '150%' };
    default:
      throw new Error(`Unrecognized origin: ${origin}`);
  }
}

function OriginDemo({ variant, rotation, x, origin }) {
  const transform = `rotate(${rotation}deg) translateX(${x}px)`;

  const styles = useSpring({
    transform,
  });

  const indicatorPosition = getIndicatorPosition(origin);

  return (
    <Wrapper>
      <BoxWrapper layout>
        <Box style={{ ...styles, transformOrigin: origin }} />
        <IndicatorWrapper>
          <Indicator layout style={indicatorPosition} />
        </IndicatorWrapper>
      </BoxWrapper>
      <Code>
        transform: {transform};
        <br />
        transform-origin: {origin};
      </Code>
    </Wrapper>
  );
}

const BoxWrapper = styled(motion.div)`
  position: relative;
  width: fit-content;
`;

const IndicatorWrapper = styled(motion.div)`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  transform: translate(-8px, -8px);
`;

const Indicator = styled(motion.div)`
  position: absolute;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 4px solid black;
  background: white;
  transition: opacity 500ms;
`;

export default OriginDemo;
